export default __webpack_public_path__ + "static/media/LeadCENTER_Rev_RGB.722d2e85.png";